module.exports = __webpack_public_path__ + "static/assets/54d38e612e1eca478aacdc6fb2a67380.svg";